<template>
  <q-page class="q-px-md">
    <client-loader :client-id="clientId" v-model="client" />
    <div v-if="client">
      <h1 class="text-h5">
        <client-name :client="client" />
      </h1>
    </div>
    <div class="row">
      <div class="offset-1 col-10">
        <accounts-list
          :client-id="clientId"
          :platforms="platforms"
          v-model:accounts="accounts"
          v-model:platform="platform"
          @update:platforms="setPlatforms"
        />
      </div>
    </div>
  </q-page>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ClientLoader from '@/client/ClientLoader.vue';
import { Client } from '@/type';
import ClientName from '@/client/ClientName.vue';
import AccountsList from '@/social/account/list/AccountsList.vue';
import { Account, Platform } from '@/social/types';

interface Data {
  client: Client|null,
  platforms: Platform[],
  accounts: Account[],
  platform: Platform|null
}

export default defineComponent({
  meta: {
    title: 'Client',
  },
  components: {
    AccountsList,
    ClientName,
    ClientLoader,
  },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      client: null,
      platforms: [],
      accounts: [],
      platform: null,
    };
  },
  methods: {
    setPlatforms(platforms: Platform[]): void {
      this.platforms = platforms;
      if (platforms.length > 0) {
        [this.platform] = platforms;
      }
    },
  },
});
</script>
